module.exports = __webpack_public_path__ + "img/alexa_icon.bff218ef.png";